import { AnyIfEmpty } from "react-redux";
import { GET_LOCATIONS_COMPREHENSIVE_FAILURE, GET_LOCATIONS_COMPREHENSIVE_REQUEST, GET_LOCATIONS_COMPREHENSIVE_SUCCESS, RESET_LOCATIONS_COMPREHENSIVE_MESSAGE } from "../constants/locationsComprehensive.constant";

interface LocationsComprehensiveState {
    loading: boolean;
    error: string;
    data: null;
}

const initialState: LocationsComprehensiveState = {
    loading: false,
    error: '',
    data: null,
};

export const locationsComprehensiveReducer = (
    state = initialState, action: { type: string; payload: AnyIfEmpty<object> }
): LocationsComprehensiveState => {
    switch (action.type) {
        case GET_LOCATIONS_COMPREHENSIVE_REQUEST:
            return { ...state, loading: true, error: '' };

        case GET_LOCATIONS_COMPREHENSIVE_SUCCESS:
            return { ...state, loading: false, data: action.payload };

        case GET_LOCATIONS_COMPREHENSIVE_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case RESET_LOCATIONS_COMPREHENSIVE_MESSAGE:
            return { ...state, data: null, error: '' };
        default:
            return state;
    }
};
